$youtubeConfirmButton = $(".js-youtube_confirm_button");

$youtubeConfirmButton.on("click", function(e){
    e.preventDefault();
    $con = $(this).parents(".js-youtube_confirm");
    $input = $con.find(".js-youtube_confirm_input");

    if($input.prop("checked")){
        $.ajax({
            url:$(".js-youtube_confirm_form").attr("action"),
            type:'POST',
            data: $(".js-youtube_confirm_form").serialize(),
        }).done(function(){
            $(".js-youtube_confirm").each(function(){
                youTubeSchowIframe($(this));
            });
        });
    }else{
        youTubeSchowIframe($con);
    }
})

function youTubeSchowIframe($con){
    // $con.find(".js-youtube_confirm_loader").removeClass("youtube_confirm_loader_con-hide");
    // $con.find(".js-youtube_confirm_form").hide(0);
    // $con.find(".js-youtube_confirm_text").hide(0);
    // $con.find(".js-youtube_confirm_button").hide(0);
    $iframe = $con.siblings("iframe");
    $iframe[0].src = $iframe.data("src");

    $con.fadeOut(600);


    // $iframe.on('load', function(){
    //     $con.fadeOut(300);
    // });
}